import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
//共通コンポーネント
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import PostcodeTextField from "../../../ui/PostcodeTextField";
import DateField from "../../../ui/DateField";
import Button from "../../../ui/Button";
import RadioGroup from "../../../ui/RadioGroup";
import Select from "../../../ui/Select";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Annotation from "../../../ui/Annotation";
import Explanation from "../../../layout/admin/Explanation";
import Completion from "./Completion";
import {
  calcEndOfYearAge,
  getDefaultCalendar,
} from "../../../../utils/calcAge";
//バリデーター
import {
  validateRequired,
  validateMaxlength,
  validateEmailAddress,
  validateConfirm,
  validateNonNegInt,
  validateMinlength,
  validatePostcode,
  validateStudentId,
  validateGenerationId,
  validateDifferentVal,
  validateHalfAlphaNum,
  validateStudentIdAlignment,
} from "../../../../utils/validate";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  postAddStudent,
  GetStudentDetail,
  postUpdateStudent,
  GetLoginIdIsExist,
} from "../../../../services/apiStudent";

const displayTypeNew = "new"; //画面モード_新規
const displayTypeUpdate = "update"; //画面モード_更新

const approvalStatusApporoval = 1; //承認ステータス_承認済み

const StudentDetailEdit = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    formState: { errors },
  } = useForm();

  //新規:new / 更新:update
  const { mode: displaytype } = useParams();
  //ユーザーID
  const { userId } = useParams();
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  //区分データ
  const [codeElement009, SetCodeElementStudentType] = useState([]);
  // 確認画面
  const [isConfirmation, setIsConfirmation] = useState(false);
  const navigate = useNavigate();
  const pagetop = useRef();

  //ラジオボタン選択値
  const [selectedIsMail, setSelectedIsMail] = useState(false);
  const [selectedIsRejection, setSelectedIsRejection] = useState(false);
  const [selectedIsGraduation, setSelectedIsGraduation] = useState(false);
  const [selectedStudentType, setSelectedStudentType] = useState();
  const [selectedIsChangePW, setSelectedIsChangePW] = useState(false);
  const [selectedIsSendMail, setSelectedIsSendMail] = useState(false);
  const [selectedIsWheelchair, setSelectedIsWheelchair] = useState(false);

  // 年齢再計算
  const [birth_day, setBirthDay] = useState();
  //再計算処理
  useEffect(() => {
    const isDate = (d) => !isNaN(new Date(d).getTime());
    if (!birth_day || !isDate(birth_day)) {
      setValue("age", "--歳");
      return;
    }
    const age = calcEndOfYearAge(birth_day);
    setValue("age", age + "歳");
  }, [birth_day]);

  useEffect(() => {
    (async function () {
      //区分値を設定
      const data = await getCodeMasterList({ code: "CD009" });
      SetCodeElementStudentType(
        data.map((d) => {
          if (d.is_init === 1) {
            setSelectedStudentType(d.d_value);
            setValue("student_type", d.d_value);
          }
          return {
            label: d.d_text,
            value: d.d_value,
            defaultChecked: d.is_init,
          };
        })
      );

      //  初回レンダリング
      if (displaytype === displayTypeNew) {
        //新規の場合、学生IDの表示を変更・都道府県を固定
        setValue("login_id", "自動で割り振られます。");
        setValue("pref", "東京都");
        setValue("birthday", getDefaultCalendar());
        setBirthDay(getDefaultCalendar());
        setValue("is_graduation", false);
        setValue("is_rejection", false);
        setValue("is_email", false);
        setValue("student_type", 1);
        //提出日にその日の日付を設定
        const today = new Date();
        setValue("filing_date", today.toISOString().split("T")[0]);
      } else if (displaytype === displayTypeUpdate) {
        const userData = await GetStudentDetail(userId);
        if (
          Object.keys(userData).length === 0 ||
          userData?.approval_status !== approvalStatusApporoval
        ) {
          navigate("/admin/404");
          return;
        }
        setValue("updated_at", userData.updated_at);
        setValue("contacts_updated_at_1", userData.contacts_updated_at_1);
        setValue("contacts_updated_at_2", userData.contacts_updated_at_2);
        setValue("login_id", userData.login_id);
        setValue("generation_id", userData.generation_id);
        setValue("name", userData.name);
        setValue("name_kana", userData.name_kana);
        setValue("postcode", userData.postcode);
        setValue("pref", userData.pref);
        setValue("street_name1", userData.street_name1);
        setValue("street_name2", userData.street_name2);
        setValue("address", userData.address);
        setValue("street_name3", userData.street_name3);
        setValue("birthday", userData.birthday);
        setBirthDay(userData.birthday);
        setValue("gender", userData.gender);
        setValue("phone_1", userData.phone_1);
        setValue("mail_1", userData.mail_1);
        setValue("mail_1_check", userData.mail_1);
        setValue("phone_2", userData.phone_2);
        setValue("mail_2", userData.mail_2);
        setValue("mail_2_check", userData.mail_2);
        setValue("emergency_name", userData.emergency_name);
        setValue("emergency_emereletion", userData.emergency_emereletion);
        setValue("emergency_phone", userData.emergency_phone);
        setValue("total_units", userData.total_units);
        setValue("filing_date", userData.filing_date);

        setSelectedIsGraduation(userData.is_graduation);
        setValue("is_graduation", userData.is_graduation);
        setSelectedIsRejection(userData.is_rejection);
        setValue("is_rejection", userData.is_rejection);
        setSelectedIsMail(userData.is_email);
        setValue("is_email", userData.is_email);
        setSelectedStudentType(userData.student_type);
        setValue("student_type", userData.student_type);
        setSelectedIsWheelchair(userData.is_wheelchair);
        setValue("is_wheelchair", userData.is_wheelchair);
      }
    })();
  }, []);

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  const handleBack = (e) => {
    if (isConfirmation) {
      scrollTop();
      setIsConfirmation(false);
      return;
    } else {
      //一覧画面に遷移
      navigate("/admin/student");
      return;
    }
  };

  const onSubmit = (data) => {
    (async function () {
      if (!isConfirmation) {
        if (displaytype === displayTypeUpdate) {
          const checkResult = await GetLoginIdIsExist({
            login_id: data.login_id,
            id: userId,
          });
          if (checkResult?.is_exist === true) {
            setError("login_id", {
              type: "manual",
              message: "この学生番号はすでに使われています",
            });
            scrollTop();
            return; //確認画面に移行せずリターン
          }
        }
        // 画面スクロールを一番上に移動
        setIsConfirmation(true);
        scrollTop();
        return;
      }
      if (isConfirmation) {
        switch (displaytype) {
          case displayTypeNew:
            await postAddStudent(data);
            // 完了画面表示
            setIsCompFlg(true);
            scrollTop();
            break;
          case displayTypeUpdate:
            postUpdateStudent(userId, data);
            setIsCompFlg(true);
            scrollTop();
            break;
          default:
            break;
        }
      }
    })();
  };

  return (
    <>
      {isCompFlg ? (
        <Completion
          subtitle={"学生登録完了"}
          explanation={"学生の登録が完了いたしました。"}
          link={"/admin/student"}
          btntext="一覧へ戻る"
        ></Completion>
      ) : (
        <div className={styles.main} ref={pagetop}>
          <ScreenTitle>学生管理</ScreenTitle>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <SubScreenTitle>
              {displaytype === displayTypeNew ? "学生新規登録" : "学生情報変更"}
            </SubScreenTitle>
            <Explanation>
              {isConfirmation
                ? "入力内容をご確認の上、登録ボタンを押してください。"
                : "必要事項をご入力の上、確認ボタンを押してください。"}
            </Explanation>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  type="hidden"
                  name="updated_at"
                  errors={errors}
                  register={register}
                ></TextField>
                <TextField
                  type="hidden"
                  name="contacts_updated_at_1"
                  errors={errors}
                  register={register}
                ></TextField>
                <TextField
                  type="hidden"
                  name="contacts_updated_at_2"
                  errors={errors}
                  register={register}
                ></TextField>
              </tr>
              <tr>
                {displaytype === displayTypeNew ? (
                  <TextField
                    type={isConfirmation ? "hidden" : "text"}
                    register={register}
                    readOnly={true}
                    name="login_id"
                    errors={errors}
                    label="学生番号(8桁)"
                    placeholder="学生番号(8桁)"
                  ></TextField>
                ) : (
                  <TextField
                    register={register}
                    validation={{
                      ...validateRequired(),
                      ...validateStudentId(),
                      ...validateStudentIdAlignment(
                        "login_id",
                        "generation_id",
                        "学生番号の上4桁と期生IDは同じにしてください"
                      ),
                    }}
                    name="login_id"
                    errors={errors}
                    label="学生番号(8桁)"
                    placeholder="学生番号(8桁)"
                    isStatic={isConfirmation}
                    required={true}
                  ></TextField>
                )}
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateGenerationId(),
                  }}
                  name="generation_id"
                  errors={errors}
                  label="期生ID(入学年月)"
                  placeholder="期生ID(入学年月)"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(30),
                  }}
                  name="name"
                  errors={errors}
                  label="氏名"
                  placeholder="氏名"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(30),
                  }}
                  name="name_kana"
                  errors={errors}
                  label="フリガナ"
                  placeholder="フリガナ"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <PostcodeTextField
                  register={register}
                  validation={{
                    ...validatePostcode(),
                  }}
                  name="postcode"
                  errors={errors}
                  setValue={setValue}
                  addressField="street_name1"
                  label="郵便番号"
                  placeholder="郵便番号"
                  isStatic={isConfirmation}
                ></PostcodeTextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{}}
                  name="pref"
                  errors={errors}
                  label="都道府県"
                  isStatic={true}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(30),
                  }}
                  name="street_name1"
                  errors={errors}
                  label="町名"
                  placeholder="町名"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(30),
                  }}
                  name="street_name2"
                  errors={errors}
                  label="丁名"
                  placeholder="丁名"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(30),
                  }}
                  name="address"
                  errors={errors}
                  label="番地・号"
                  placeholder="番地・号"
                  isStatic={isConfirmation}
                  required={true}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(60),
                  }}
                  name="street_name3"
                  errors={errors}
                  label="方書き"
                  placeholder="方書き"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <DateField
                  onChange={(event) => setBirthDay(event.target.value)}
                  type="date"
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  name="birthday"
                  errors={errors}
                  label="生年月日"
                  placeholder="生年月日"
                  isStatic={isConfirmation}
                  required={true}
                  watch={watch}
                ></DateField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{}}
                  name="age"
                  errors={errors}
                  label="年齢(年度末時点)"
                  placeholder="年齢(年度末時点)"
                  isStatic={true}
                ></TextField>
              </tr>
              <tr>
                <Select
                  register={register}
                  validation={{}}
                  label="性別"
                  name="gender"
                  errors={errors}
                  options={[
                    { text: "男", value: "男" },
                    { text: "女", value: "女" },
                  ]}
                  watch={watch}
                  defalut={{ text: "---選択していません---", value: "" }}
                  isSetdefalut={true}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(20),
                  }}
                  name="phone_1"
                  errors={errors}
                  label="電話番号1"
                  placeholder="電話番号1"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                    ...validateEmailAddress(),
                  }}
                  name="mail_1"
                  errors={errors}
                  label="メールアドレス1"
                  placeholder="メールアドレス1"
                  isStatic={isConfirmation}
                ></TextField>
                {isConfirmation ? (
                  <></>
                ) : (
                  <>
                    <tr>
                      <Annotation>{"(確認用)"}</Annotation>
                    </tr>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(100),
                        ...validateEmailAddress(),
                        ...validateConfirm(
                          "mail_1",
                          "mail_1_check",
                          "メールアドレス"
                        ),
                      }}
                      name="mail_1_check"
                      errors={errors}
                      placeholder="メールアドレス1(確認用)"
                      isStatic={isConfirmation}
                    ></TextField>
                  </>
                )}
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(20),
                    ...validateDifferentVal(
                      "phone_1",
                      "phone_2",
                      "電話番号1と2"
                    ),
                  }}
                  name="phone_2"
                  errors={errors}
                  label="電話番号2"
                  placeholder="電話番号2"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                    ...validateEmailAddress(),
                    ...validateDifferentVal(
                      "mail_1",
                      "mail_2",
                      "メールアドレス1と2"
                    ),
                  }}
                  name="mail_2"
                  errors={errors}
                  label="メールアドレス2"
                  placeholder="メールアドレス2"
                  isStatic={isConfirmation}
                ></TextField>
                {isConfirmation ? (
                  <></>
                ) : (
                  <>
                    <tr>
                      <Annotation>{"(確認用)"}</Annotation>
                    </tr>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(100),
                        ...validateEmailAddress(),
                        ...validateConfirm(
                          "mail_2",
                          "mail_2_check",
                          "メールアドレス"
                        ),
                      }}
                      name="mail_2_check"
                      errors={errors}
                      placeholder="メールアドレス2(確認用)"
                      isStatic={isConfirmation}
                    ></TextField>
                  </>
                )}
              </tr>
              {displaytype === displayTypeNew ? (
                // 新規時のパスワード欄
                <>
                  <tr>
                    <TextField
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateHalfAlphaNum(),
                        ...validateMaxlength(12),
                        ...validateMinlength(8),
                      }}
                      name="password"
                      type="password"
                      errors={errors}
                      label="パスワード"
                      placeholder="パスワード"
                      isStatic={isConfirmation}
                      required={true}
                    ></TextField>
                  </tr>
                  {isConfirmation ? (
                    <></>
                  ) : (
                    <>
                      <tr>
                        <Annotation>{"(確認用)"}</Annotation>
                      </tr>
                      <tr>
                        <TextField
                          register={register}
                          validation={{
                            ...validateConfirm(
                              "password",
                              "password_check",
                              "パスワード"
                            ),
                          }}
                          name="password_check"
                          type="password"
                          errors={errors}
                          placeholder="パスワード(確認用)"
                          isStatic={isConfirmation}
                        ></TextField>
                      </tr>
                    </>
                  )}
                </>
              ) : (
                // 更新時のパスワード欄
                <>
                  <tr>
                    <RadioGroup
                      errors={errors}
                      register={register}
                      label="パスワード"
                      name="is_change_pw"
                      elements={[
                        { label: "変更しない", value: false },
                        { label: "変更する", value: true },
                      ]}
                      watch={watch}
                      isStatic={isConfirmation}
                      selectedValue={selectedIsChangePW}
                      setSelectedValue={setSelectedIsChangePW}
                    />
                  </tr>
                  {selectedIsChangePW ? (
                    <>
                      <tr>
                        <Annotation>新しいパスワード</Annotation>
                      </tr>
                      <tr>
                        <TextField
                          register={register}
                          validation={{
                            ...validateRequired(),
                            ...validateHalfAlphaNum(),
                            ...validateMaxlength(12),
                            ...validateMinlength(8),
                          }}
                          name="password"
                          type="password"
                          errors={errors}
                          placeholder="パスワード"
                          isStatic={isConfirmation}
                        ></TextField>
                      </tr>
                      {isConfirmation ? (
                        <></>
                      ) : (
                        <>
                          <tr>
                            <Annotation>(確認用)</Annotation>
                          </tr>
                          <tr>
                            <TextField
                              register={register}
                              validation={{
                                ...validateConfirm(
                                  "password",
                                  "password_check",
                                  "パスワード"
                                ),
                              }}
                              name="password_check"
                              type="password"
                              errors={errors}
                              placeholder="パスワード(確認用)"
                              isStatic={isConfirmation}
                            ></TextField>
                          </tr>
                        </>
                      )}
                      <tr>
                        <RadioGroup
                          errors={errors}
                          register={register}
                          label="入学手続き完了メール"
                          name="is_send_mail"
                          elements={[
                            { label: "送信しない", value: false },
                            { label: "送信する", value: true },
                          ]}
                          watch={watch}
                          isStatic={isConfirmation}
                          selectedValue={selectedIsSendMail}
                          setSelectedValue={setSelectedIsSendMail}
                        />
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(30),
                  }}
                  name="emergency_name"
                  errors={errors}
                  label="緊急連絡先(氏名)"
                  placeholder="緊急連絡先(氏名)"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(30),
                  }}
                  name="emergency_emereletion"
                  errors={errors}
                  label="緊急連絡先(続柄)"
                  placeholder="緊急連絡先(続柄)"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(20),
                  }}
                  name="emergency_phone"
                  errors={errors}
                  label="緊急連絡先(電話番号)"
                  placeholder="緊急連絡先(電話番号)"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <DateField
                  type="date"
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  name="filing_date"
                  errors={errors}
                  label="提出日"
                  placeholder="提出日"
                  required={true}
                  isStatic={isConfirmation}
                  watch={watch}
                ></DateField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(5),
                    ...validateNonNegInt(),
                  }}
                  name="total_units"
                  errors={errors}
                  label="総単位数"
                  placeholder="総単位数"
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                {displaytype === displayTypeUpdate ? (
                  <RadioGroup
                    errors={errors}
                    register={register}
                    label="メール配信"
                    name="is_email"
                    elements={[
                      { label: "配信する", value: true },
                      { label: "配信しない", value: false },
                    ]}
                    watch={watch}
                    isStatic={isConfirmation}
                    selectedValue={selectedIsMail}
                    setSelectedValue={setSelectedIsMail}
                  />
                ) : (
                  ""
                )}
              </tr>
              <tr>
                {displaytype === displayTypeUpdate ? (
                  //新規時は非表示
                  <RadioGroup
                    errors={errors}
                    register={register}
                    label="ログイン拒否"
                    name="is_rejection"
                    elements={[
                      { label: "ログイン可", value: false },
                      { label: "ログイン不可", value: true },
                    ]}
                    watch={watch}
                    isStatic={isConfirmation}
                    selectedValue={selectedIsRejection}
                    setSelectedValue={setSelectedIsRejection}
                  />
                ) : (
                  ""
                )}
              </tr>
              <tr>
                {displaytype === displayTypeUpdate ? (
                  <RadioGroup
                    errors={errors}
                    register={register}
                    label="在校生・卒業生"
                    name="is_graduation"
                    elements={[
                      { label: "在校生", value: false },
                      { label: "卒業生", value: true, defaultChecked: true },
                    ]}
                    watch={watch}
                    isStatic={isConfirmation}
                    selectedValue={selectedIsGraduation}
                    setSelectedValue={setSelectedIsGraduation}
                  />
                ) : (
                  ""
                )}
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="学生区分"
                  name="student_type"
                  elements={codeElement009}
                  watch={watch}
                  selectedValue={selectedStudentType}
                  setSelectedValue={setSelectedStudentType}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="車いす"
                  name="is_wheelchair"
                  watch={watch}
                  selectedValue={selectedIsWheelchair}
                  setSelectedValue={setSelectedIsWheelchair}
                  elements={[
                    { label: "非該当", value: false },
                    { label: "該当", value: true },
                  ]}
                  isStatic={isConfirmation}
                />
              </tr>
            </table>
            <div className={styles.buttonbox}>
              <Button
                type="button"
                styleType="back"
                onClick={() => handleBack()}
              >
                {isConfirmation ? "変更ページへ戻る" : "一覧へ戻る"}
              </Button>
              <Button type="submit" styleType="new">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
            {isConfirmation ? (
              <></>
            ) : (
              <div className={styles.buttonbox}>
                <Link className={styles.link} to="/admin/top">
                  トップページへ戻る
                </Link>
              </div>
            )}
          </Form>
        </div>
      )}
    </>
  );
};
export default StudentDetailEdit;
